module.exports = __webpack_public_path__ + "img/ic_testPaper.3c37e8aa.svg";